<!-- 건강상담 -->
<template>
  <div class="print-container">
    <div class="flex items-center justify-between mb-5">
      <h5 class="flex items-center"><i class="dot"></i>건강상담</h5>
      <div v-if="!readonly && !isPrint" class="flex items-center gap-2">
        <vs-button color="secondary" type="flat" @click="fold = false"><img src="@/assets/images/icon/IconTriangleDown.svg" class="inline-block align-middle" /> 모두펼치기</vs-button>
        <hr class="-mx-2" style="height: 20px; border-width: 1px; border-color: #6670cb; border-left: 0" />
        <vs-button color="secondary" type="flat" @click="fold = true"> <img src="@/assets/images/icon/IconTriangleDown.svg" class="inline-block align-middle" style="transform: rotate( 180deg );" /> 모두접기</vs-button>
        <vs-button color="secondary" type="border" @click="handleAddRow"> 항목추가 </vs-button>
        <vs-button color="secondary" @click="handleRemoveRow"> 선택삭제 </vs-button>
      </div>
    </div>
    <div v-show="!fold"  v-for="(item, index) in list" :key="item.id" class="content-container mt-5">
      <div v-if="!readonly && !isPrint" class="checkbox-container z-10">
        <vs-checkbox :vs-value="item.id" v-model="checkData" class="checkbox" />
      </div>
      <div style="width: calc(100% - 36px); overflow-x: auto">
        <table style="min-width: 1340px">
          <colgroup>
            <col width="100" />
            <col width="250" />
            <col width="100" />
            <col />
            <col />
            <col width="100" />
            <col />
            <col width="100" />
            <col width="70" />
            <col width="70" />
            <col width="70" />
            <col width="70" />
          </colgroup>
          <tr>
            <th>일자</th>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.input_7 }}</p>
              <date-selector v-else v-model="item.input_7" :readonly="readonly" class="w-full" />
            </td>
            <th>시간</th>
            <td colspan="2">
              <p v-if="isPrint" class="print-input">{{ item.input_8 }}</p>
              <time-selector v-else v-model="item.input_8" :readonly="readonly" class="w-full" />
            </td>
            <th>차기방문일</th>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.input_9 }}</p>
              <date-selector v-else v-model="item.input_9" :readonly="readonly" class="w-full" />
            </td>
            <th>상담자</th>
            <td colspan="4">
              <p v-if="isPrint" class="print-input">{{ item.input_10 }}</p>
              <vs-select v-else v-model="item.input_10" autocomplete :readonly="readonly" :disabled="readonly" class="w-full">
                <vs-select-item v-for="option in ['보건관리자', '의사']" :key="option" :text="option" :value="option" />
              </vs-select>
            </td>
          </tr>
          <tr>
            <th rowspan="2">교육내용</th>
            <td rowspan="2" class="p-0">
              <ul>
                <li>
                  <p>전문의 진료 권장/확인서류 제출</p>
                  <div>
                    <PrintCheckbox v-if="isPrint" label="" :value="item.input_11" color />
                    <vs-checkbox v-else v-model="item.input_11" :readonly="readonly" class="checkbox" />
                  </div>
                </li>
                <li>
                  <p>주기적 건강체크 권장</p>
                  <div>
                    <PrintCheckbox v-if="isPrint" label="" :value="item.input_12" color />
                    <vs-checkbox v-else v-model="item.input_12" :readonly="readonly" class="checkbox" />
                  </div>
                </li>
                <li>
                  <p>생활요법 권장</p>
                  <div>
                    <PrintCheckbox v-if="isPrint" label="" :value="item.input_13" color />
                    <vs-checkbox v-else v-model="item.input_13" :readonly="readonly" class="checkbox" />
                  </div>
                </li>
              </ul>
            </td>
            <th rowspan="2">간이검사</th>
            <th>혈압</th>
            <th>혈당</th>
            <th rowspan="2">체지방</th>
            <td rowspan="2" class="align-middle">
              <p v-if="isPrint" class="print-input">{{ item.input_14 }}</p>
              <ml-input v-else v-model="item.input_14" :readonly="readonly" class="w-full" />
            </td>
            <th rowspan="2">콜레스테롤</th>
            <th>TC</th>
            <th>TG</th>
            <th>HDL</th>
            <th>LDL</th>
          </tr>
          <tr>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.input_15 }}</p>
              <ml-input v-else v-model="item.input_15" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.input_16 }}</p>
              <ml-input v-else v-model="item.input_16" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.input_17 }}</p>
              <ml-input v-else v-model="item.input_17" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.input_18 }}</p>
              <ml-input v-else v-model="item.input_18" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.input_19 }}</p>
              <ml-input v-else v-model="item.input_19" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.input_20 }}</p>
              <ml-input v-else v-model="item.input_20" :readonly="readonly" class="w-full" />
            </td>
          </tr>
          <tr>
            <th>
              <div class="flex items-center justify-center gap-2">
                <vx-tooltip html="실제로 [유소견자 건강 상담 실적 통계]페이지에 집계되는 데이터 입니다." style="margin-left: 4px; display: flex; align-items: center; justify-content: center" position="top" delay=".1s">
                  <feather-icon icon="AlertCircleIcon" style="cursor: pointer; width: 16px" />
                </vx-tooltip>
                <p>검진항목</p>
              </div>
            </th>
            <td colspan="4">
              <div class="h-full flex flex-col justify-center">
                <div class="flex items-center gap-5 mb-2">
                  <PrintCheckbox v-if="isPrint" :value="!!item.input_21['일반검진']" label="일반검진" class="justify-center" />
                  <vs-checkbox v-else vs-value="일반검진" :value="!!item.input_21['일반검진']" @input="(value21) => setInput21(index, value21)" :readonly="readonly">일반검진</vs-checkbox>
                  <div v-if="!!item.input_21['일반검진']" class="flex items-center">
                    <p>건강관리구분 판정 :</p>
                    <div v-for="check in ['C2', 'D2']" :key="check">
                      <PrintCheckbox v-if="isPrint" :label="check" :value="item.input_21['일반검진'].includes(check)" color class="ml-2" />
                      <vs-checkbox v-else :vs-value="check" v-model="item.input_21['일반검진']" :readonly="readonly" class="checkbox">
                        <p class="ml-2">{{ check }}</p>
                      </vs-checkbox>
                    </div>
                  </div>
                </div>
                <div class="flex items-center gap-5 mb-2">
                  <PrintCheckbox v-if="isPrint" :value="!!item.input_21['배치전 검진']" label="배치전 검진" class="justify-center" />
                  <vs-checkbox v-else vs-value="배치전 검진" :value="!!item.input_21['배치전 검진']" @input="(value21) => setInput21(index, value21)" :readonly="readonly">배치전 검진</vs-checkbox>
                  <div v-if="!!item.input_21['배치전 검진']" class="flex items-center">
                    <p>건강관리구분 판정 :</p>
                    <div v-for="check in ['A', 'C1', 'C2', 'CN', 'D1', 'D2', 'R']" :key="check">
                      <PrintCheckbox v-if="isPrint" :label="check" :value="item.input_21['배치전 검진'].includes(check)" color class="ml-2" />
                      <vs-checkbox v-else :vs-value="check" v-model="item.input_21['배치전 검진']" :readonly="readonly" class="checkbox">
                        <p class="ml-2">{{ check }}</p>
                      </vs-checkbox>
                    </div>
                  </div>
                </div>
                <div class="flex items-center gap-5">
                  <PrintCheckbox v-if="isPrint" :value="!!item.input_21['특수검진']" label="특수검진" class="justify-center" />
                  <vs-checkbox v-else vs-value="특수검진" :value="!!item.input_21['특수검진']" @input="(value21) => setInput21(index, value21)" :readonly="readonly">특수검진</vs-checkbox>
                  <div v-if="!!item.input_21['특수검진']" class="flex items-center">
                    <p>건강관리구분 판정 :</p>
                    <div v-for="check in ['A', 'C1', 'C2', 'CN', 'D1', 'D2', 'R']" :key="check">
                      <PrintCheckbox v-if="isPrint" :label="check" :value="item.input_21['특수검진'].includes(check)" color class="ml-2" />
                      <vs-checkbox v-else :vs-value="check" v-model="item.input_21['특수검진']" :readonly="readonly" class="checkbox">
                        <p class="ml-2">{{ check }}</p>
                      </vs-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <th>사후관리조치</th>
            <td colspan="6">
              <ml-textarea v-model="item.input_23" :readonly="readonly" class="w-full" />
            </td>
          </tr>
          <tr>
            <th>상담내용</th>
            <td colspan="11">
              <ml-textarea v-model="item.input_22" :readonly="readonly" class="w-full" />
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
export default {
  components: {
    DateSelector,
    TimeSelector,
    PrintCheckbox,
  },
  props: {
    value: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fold:false,
      checkData: [],
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
      list: this.value,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // 항목추가
    handleAddRow() {
      const addData = { id: ++this.numberId, input_10: "보건관리자", input_21: {} };
      this.list.unshift(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },
    setInput21(index, value) {
      if (!!this.list[index].input_21[value]) this.$delete(this.list[index].input_21, value);
      else this.$set(this.list[index].input_21, value, []);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox::v-deep {
  justify-content: center !important;
  span {
    margin: 0px !important;
  }
}
.content-container {
  display: flex;
  table:nth-child(n + 2) {
    margin-top: -1px;
  }
}

.checkbox-container {
  width: 36px;

  display: flex;
  justify-content: center;

  background: #f9f9f9;
  border: 1px solid #cdcdcd;
}
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  margin-left: -1px;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    background: #f9f9f9;
    padding: 18px 0px;
  }

  td {
    height: 1px;
    vertical-align: top;
    padding: 7px;

    ul {
      width: 100%;
      height: 100%;

      display: flex;
      flex-direction: column;
      justify-content: space-between;

      li {
        flex: 1;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #cdcdcd;
        p {
          flex: 1;
          padding: 7px;
        }

        & > div {
          height: 100%;
          display: flex;
          align-items: center;
          justify-items: center;
          border-left: 1px solid #cdcdcd;
          padding: 7px;
        }

        &:last-child {
          border-bottom: 0px;
        }
      }
    }
  }
}
</style>
